import React from 'react'
import { keyframes } from '@emotion/react'
import { Box, BoxProps } from '../'

export const Whisper = (
    props: BoxProps & {
        variant?: 'text' | 'circle'
    }
) => {
    const { sx, variant = 'text' } = props

    const waveAnimation = keyframes`
        0% { transform: translateX(-150%); }
        100% { transform: translateX(150%); }
    `

    return (
        <Box
            sx={{
                ...sx,
                'position': 'relative',
                'overflow': 'hidden',
                'height': sx && sx['height'] ? sx['height'] : '100%',
                'width': sx && sx['width'] ? sx['width'] : '100%',
                'background': 'white',
                'borderRadius': variant === 'circle' ? '50%' : 2,
                'transform': 'translateZ(0)',
                '::after': {
                    animation: `${waveAnimation} 2.5s linear 100ms infinite`,
                    background: t =>
                        `linear-gradient(90deg, ${t.colors?.white}, ${t.colors?.oat}, ${t.colors?.white})`,
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: 300,
                    top: 0
                }
            }}
        ></Box>
    )
}
